import React from 'react';
import YoutubeBigFormPage from 'pages/Configuration/ConfigurationViews/ConfigurationWidget/WidgetsForms/Youtube/YoutubeBig';
import * as Yup from 'yup';
import WidgetForm from '../WidgetForm';
import useFirebase from '../../../../hooks/Firebase/useFirebase';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const YBForm = {
    channel: {
        name: "channel",
        placeholder: "Channel name",
        label: "Name of the channel",
        required: true
    },
    timer: {
        name: "timer",
        placeholder: "Timer (ms)",
        label: "Refresh timer",
        required: true
    }
}

const YBValidate = Yup.object().shape({
    [YBForm.channel.name]: Yup.string().required("Required"),
    [YBForm.timer.name]: Yup.number().required("Required"),
})

const YoutubeBigForm = (props) => {
    const [, addElement] = useFirebase();
    const [YBInitial, setYBInitial] = React.useState({
        [YBForm.channel.name]: "",
        [YBForm.timer.name]: "",
    });
    const {widgets} = useSelector(state => state.widgets);

    React.useEffect(() => {
        if (props.widget) {
            setYBInitial(props.widget);
        }
    }, [props.widget])

    const handleSubmit = (values, formikBag) => {
        if (props.handleEdit) {
            props.handleEdit(values);
            const valuesParsed = widgets?.map(el => {
                if (el.id === props.widgetID) {
                    return {
                        ...el.widget,
                        ...values,
                    };
                }
                return el.widget;
            })
            addElement.setWidget("users", valuesParsed)
            toast("The widget was updated !");
            return
        }
        addElement.widget("users", {
            service_id: props.serviceSelected.id,
            widget_id: props.widgetSelected.id,
            timer: values[YBForm.timer.name],
            channel: values[YBForm.channel.name]
        });

        formikBag.resetForm()
        toast("The widget was added to your dashboard !");
    }

    return (
        <WidgetForm WForm={YBForm} WInitial={YBInitial} WValidate={YBValidate} handleSubmit={handleSubmit}>
            <YoutubeBigFormPage handleEdit={props.handleEdit} />
        </WidgetForm>
    );
};

export default YoutubeBigForm;